var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgCircleArrowRightUp = function SvgCircleArrowRightUp(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 9,
    r: 8.78571,
    stroke: "currentColor",
    strokeWidth: 0.428571
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.57586 10.818C6.40849 10.9854 6.40849 11.2568 6.57586 11.4241C6.74323 11.5915 7.01458 11.5915 7.18195 11.4241L6.57586 10.818ZM11.5501 6.87845C11.5501 6.64176 11.3582 6.44988 11.1215 6.44988L7.2644 6.44988C7.02771 6.44988 6.83583 6.64176 6.83583 6.87845C6.83583 7.11515 7.02771 7.30702 7.2644 7.30702L10.693 7.30702L10.693 10.7356C10.693 10.9723 10.8849 11.1642 11.1215 11.1642C11.3582 11.1642 11.5501 10.9723 11.5501 10.7356L11.5501 6.87845ZM7.18195 11.4241L11.4246 7.1815L10.8185 6.57541L6.57586 10.818L7.18195 11.4241Z",
    fill: "currentColor"
  })));
};
export default SvgCircleArrowRightUp;